import { render, staticRenderFns } from "./LocalJs.vue?vue&type=template&id=246680b9&scoped=true"
import script from "./LocalJs.vue?vue&type=script&lang=js"
export * from "./LocalJs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246680b9",
  null
  
)

export default component.exports